<template>
  <select is="form-multiselect" v-model="model" html select-all :placeholder="placeholder" :required="required" :parameters="parameters" v-bind="$attrs">
    <option v-if="!required" value="">{{placeholder}}</option>
    <optgroup v-for="(options, groupName) in colorsByGroup" :key="groupName" :label="groupName || '(aucun groupe)'">
      <option-html v-for="option in options" :value="option.id" :key="option.id">
        <div class="pull-left mr-5 valign-middle"><color-badge :color="option" size="mini" /></div>
        <div class="valign-middle text-default">{{option.name}}</div>
      </option-html>
    </optgroup>
  </select>
</template>

<style type="text/css" itemscope>
  .multi-select-multiple .multiselect-selected-text .text-default {
    display: none;
  }
</style>

<script>
import _filter from "lodash/filter";
import _groupBy from "lodash/groupBy";

import ColorBadge from "./ColorBadge";
import OptionHtml from "./OptionHtml";

export default {
  components: {
    FormMultiselect: () =>
      import("package-common-vuejs/src/components/form/FormMultiselect"),
    ColorBadge,
    OptionHtml
  },
  props: {
    value: [String, Array],
    placeholder: String,
    required: Boolean,
    colors: Array,
    buttonClass: String
  },
  computed: {
    colorsByGroup() {
      return _groupBy(this.colors, "group.name");
    },
    parameters() {
      return {
        enableClickableOptGroups: true,
        delimiterText: ' ',
        numberDisplayed: 10,
      };
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        if (Array.isArray(value)) {
          value = _filter(value);
        }
        this.$emit("input", value);
        this.$emit("change", value);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FormSelectColor.vue